import { createContext } from 'react';
import { CURRENCY_SYMBOLS, CurrencyCode } from './currency';

export const BETA_CUSTOMER_FLAG = 'BETA_CUSTOMER';

export const INSIGHTS = 'INSIGHTS';
export const BENCHMARKING = 'BENCHMARKING';
export const API = 'API';

export interface TenantConfig {
  name: string;
  accountNumber: string;
  isAdminView: boolean;
  isSuperAdmin: boolean;
  isSupportAdmin: boolean;
  isAdminResolved: boolean;
  onboardingStatus: string;
  testTenantFlag: boolean;
  currencyCode: CurrencyCode;
  currentDataVersion?: Date;
  featureFlags: string[];
  permissions: string[];
  updateActivationStatus: (newStatus: string) => void;
  setActiveAccountNumber: (activeAccountNumber: string) => void;
  setAdminView: (isAdminView: boolean) => void;
  reloadTenant: () => void;
}

export const TenantConfigContext = createContext<TenantConfig>({} as TenantConfig);

export class TenantConfigUtil {
  static getCurrencySymbol(currencyCode: CurrencyCode): string {
    return CURRENCY_SYMBOLS[currencyCode] ?? currencyCode;
  }
}
